import React from 'react';
import { StatusBar } from 'expo-status-bar';
import { StyleSheet, Text, View, TextInput, TouchableWithoutFeedback, TouchableOpacity, ActivityIndicator, Touchable } from 'react-native';
import { Picker } from '@react-native-picker/picker';
import { NavigationContainer } from '@react-navigation/native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { ScrollView } from 'react-native-gesture-handler';
import {
  SafeAreaView,
  SafeAreaProvider,
  SafeAreaInsetsContext,
  useSafeAreaInsets,
  initialWindowMetrics,
} from 'react-native-safe-area-context';
import DateTimePicker from '@react-native-community/datetimepicker';
import { useFonts } from 'expo-font';
import axios from 'axios';
import qs from 'qs';
import css from '../Style'
import MyText from '../MyText';
import MyTextInput from '../MyTextInput';
import MyPicker from '../MyPicker';
import Header from '../Header';
import Footer from '../Footer';
import Collapsible from 'react-native-collapsible';
import Annex from './Annex';
import ContactPerson from './ContactPerson';
import PersonsOnBoard from './PersonsOnBoard';
import MyDatePicker from '../MyDatePicker';
import MyTextarea from '../MyTextarea';
import RequestedCollectionMeans from './RequestedCollectionMeans';
import MyModal from '../MyModal';
import MyDateTimePicker from '../MyDatetimePicker';
import RequestedCollectionMeansForm from './RequestedCollectionMeansForm';
import AnnexINonHazardous from './Annex/AnnexINonHazardous';
import AnnexIINonHazardous from './Annex/AnnexIINonHazardous';
import AnnexIVNonHazardous from './Annex/AnnexIVNonHazardous';
import AnnexVNonHazardous from './Annex/AnnexVNonHazardous';
import AnnexVINonHazardous from './Annex/AnnexVINonHazardous';
import AnnexIHazardous from './Annex/AnnexIHazardous';
import AnnexIIHazardous from './Annex/AnnexIIHazardous';
import AnnexIVHazardous from './Annex/AnnexIVHazardous';
import AnnexVHazardous from './Annex/AnnexVHazardous';
import AnnexVIHazardous from './Annex/AnnexVIHazardous';
import { Entypo } from '@expo/vector-icons';
import Progress from '../Progress';

import { connect } from 'react-redux';
import { openModal, closeModal } from '../modalActions';
import RouteUpdate from './RouteUpdate';
import WasteCollection from './WasteCollection';

const NewRequest = (props) => {
    const [gotData, setGotData] = React.useState(false);

    const [isInfo, setIsInfo] = React.useState(props.isInfo);

    const [tab, setTab] = React.useState('Overview');

    const [progressData, setProgressData] = React.useState([]);
    const [routeUpdateData, setRouteUpdateData] = React.useState([]);
    const [wasteCollectionData, setWasteCollectionData] = React.useState({});

    const [dataCords0, setDataCords0] = React.useState(0);
    const [dataCords1, setDataCords1] = React.useState(0);
    const [dataCords2, setDataCords2] = React.useState(0);
    const [countryFlagCords, setCountryFlagCords] = React.useState(0);

  const [comments, setComments] = React.useState('');
  const [agent, setAgent] = React.useState('');

  const [shipEditable, setShipEditable] = React.useState(true);

  const [requestedCollectionMeans, setRequestedCollectionMeans] = React.useState([{}]);

  const scrollRef = React.useRef();

  const [grossTonnageType, setGrossTonnageType] = React.useState('m³');
  const [grtType, setGrtType] = React.useState('m³');
  const [dwtType, setDwtType] = React.useState('m³');

  const [annex1, setAnnex1] = React.useState({});
  const [annex2, setAnnex2] = React.useState({});
  const [annex4, setAnnex4] = React.useState({});
  const [annex5, setAnnex5] = React.useState({});
  const [annex6, setAnnex6] = React.useState({});

  const [annex1non, setAnnex1non] = React.useState({});
  const [annex2non, setAnnex2non] = React.useState({});
  const [annex4non, setAnnex4non] = React.useState({});
  const [annex5non, setAnnex5non] = React.useState({});
  const [annex6non, setAnnex6non] = React.useState({});

  const [annex1nonKey, setAnnex1nonKey] = React.useState(1000);
  const [annex2nonKey, setAnnex2nonKey] = React.useState(2000);
  const [annex4nonKey, setAnnex4nonKey] = React.useState(3000);
  const [annex5nonKey, setAnnex5nonKey] = React.useState(4000);
  const [annex6nonKey, setAnnex6nonKey] = React.useState(5000);

  const [annex1Key, setAnnex1Key] = React.useState(6000);
  const [annex2Key, setAnnex2Key] = React.useState(7000);
  const [annex4Key, setAnnex4Key] = React.useState(8000);
  const [annex5Key, setAnnex5Key] = React.useState(9000);
  const [annex6Key, setAnnex6Key] = React.useState(10000);

  const [requestedCollectionMeansKey, setRequestedCollectionMeansKey] = React.useState(11000);

  const [hasCheckedAnnex, setHasCheckedAnnex] = React.useState(true);

  const [status, setStatus] = React.useState('');
  const [requestedAt, setRequestedAt] = React.useState('');

    const [imo, setImo] = React.useState({
        value: '',
        hasError: false
    });
    const [shipName, setShipName] = React.useState({
        value: '',
        hasError: false
    });
    const [shipType, setShipType] = React.useState({
        value: '',
        hasError: false
    });
    const [countryFlag, setCountryFlag] = React.useState({
        value: '',
        hasError: false
    });
    const [grossTonnage, setGrossTonnage] = React.useState({
        value: '',
        hasError: false
    });
    const [grt, setGrt] = React.useState({
        value: '',
        hasError: false
    });
    const [dwt, setDwt] = React.useState({
        value: '',
        hasError: false
    });
    const [registryOffice, setRegistryOffice] = React.useState({
        value: '',
        hasError: false
    });
    const [portOfDelivery, setPortOfDelivery] = React.useState({
        value: '',
        hasError: false
    });
    const [location, setLocation] = React.useState({
        value: '',
        hasError: false
    });
    const [arrival, setArrival] = React.useState({
        value: '',
        hasError: false
    });
    const [departure, setDeparture] = React.useState({
        value: '',
        hasError: false
    });
    const [requestedDelivery, setRequestedDelivery] = React.useState({
        value: '',
        hasError: false
    });
    const [lastPort, setLastPort] = React.useState({
        value: '',
        hasError: false
    });
    const [nextPort, setNextPort] = React.useState({
        value: '',
        hasError: false
    });

    // Persons on board
    const [personsOnBoardTotal, setPersonsOnBoardTotal] = React.useState({
        value: '',
        hasError: false
    });
    const [personsOnBoardCrew, setPersonsOnBoardCrew] = React.useState({
        value: '',
        hasError: false
    });
    const [personsOnBoardPassengers, setPersonsOnBoardPassengers] = React.useState({
        value: '',
        hasError: false
    });

    //Contact person
    const [contactPersonFName, setContactPersonFName] = React.useState({
        value: '',
        hasError: false
    });
    const [contactPersonLName, setContactPersonLName] = React.useState({
        value: '',
        hasError: false
    });
    const [contactPersonProfession, setContactPersonProfession] = React.useState({
        value: '',
        hasError: false
    });
    const [contactPersonEmail, setContactPersonEmail] = React.useState({
        value: '',
        hasError: false
    });
    const [contactPersonPhone, setContactPersonPhone] = React.useState({
        value: '',
        hasError: false
    });
  
  const [countries, setCountries] = React.useState(null);
  const [collectionMeans, setCollectionMeans] = React.useState(null);
  const [companyRepresentatives, setCompanyRepresentatives] = React.useState([{}]);
  const [requestedPurposes, setRequestedPurposes] = React.useState(null);
  const [shipTypes, setShipTypes] = React.useState(null);
  const [wasteMetrics, setWasteMetrics] = React.useState(null);
  const [portOfDeliveries, setPortOfDeliveries] = React.useState(null);
  const [locations, setLocations] = React.useState(null);
  const [agents, setAgents] = React.useState(null);

  React.useEffect(() => {
    if(countries && collectionMeans && companyRepresentatives && requestedPurposes && shipTypes && wasteMetrics && portOfDeliveries && locations && agents){
        if(props.id){
            axios.get('/api/getRequest.php', {
                params: {
                    id: props.id
                }
            })
            .then((res) => {
                if(res.data.length > 0){
                    SetFormData(res.data[0].data, res.data[0].status, res.data[0].requested_at);
                    setRouteUpdateData(res.data[0].route_update);
                    setWasteCollectionData(res.data[0].waste_collection);
                    let tempProgressData = [];
                    let cancelled = false;
                    const statuses = ['Submitted', 'Validated', 'Route Scheduled', 'Driver on his Way', 'Driver Arrived', 'Waste Collected', 'Waste Segregated', 'Completed', 'Certificate Issued'];
                    res.data[0].request_progress.forEach(progress => {
                        if(progress.status.toLocaleLowerCase() === 'cancelled' || progress.status.toLocaleLowerCase() === 'rejected'){
                            cancelled = true;
                        }
                    });
                    if(!cancelled){
                        statuses.forEach(status => {
                            let found = false;
                            res.data[0].request_progress.forEach(progress => {
                                if(!found && progress.status.toLowerCase() === status.toLocaleLowerCase()){
                                    if(progress.status.toLocaleLowerCase() === 'route scheduled' || progress.status.toLocaleLowerCase() === 'driver arrived'){
                                        const drivers = res.data[0].route_update.map(route => {
                                            return route.companyRepresentative
                                        }).join(', ');
                                        progress.drivers = drivers;
                                        progress.scheduledFor = res.data[0].route_update[0].datetime;
                                    }
                                    else if(progress.status.toLocaleLowerCase() === 'waste collected'){
                                        progress.waste_collection = res.data[0].waste_collection;
                                    }
                                    tempProgressData.push(progress);
                                    found = true;
                                }
                            })
                            if(!found){
                                tempProgressData.push({status: status}); // Push empty so it's visible in the Progress tab
                            }
                        })
                    }
                    else{
                        res.data[0].request_progress.forEach(progress => {
                            if(progress.status.toLocaleLowerCase() === 'route scheduled'){
                                const drivers = res.data[0].route_update.map(route => {
                                    return route.companyRepresentative
                                }).join(', ');
                                progress.drivers = drivers;
                            }
                            tempProgressData.push(progress);
                        })
                    }
                    setProgressData(tempProgressData);
                }
            })
        }
        else{
            setGotData(true);
        }
    }
  }, [countries, collectionMeans, companyRepresentatives, requestedPurposes, shipTypes, wasteMetrics, portOfDeliveries, locations, agents])
  
    React.useEffect(() => {
        console.log("Loading");
        if(!gotData){
            if(!!!props.id){ //If we are in New Request, load form immediatelly
                setGotData(true);
            }
            axios.get('/api/getCountries.php')
            .then((res) => {
                let tempCountries = [];
                res.data.forEach(cou => {
                    tempCountries.push({key: cou.key, value: cou.value});
                })
                setCountries(tempCountries);
            })
            axios.get('/api/getCollectionMean.php')
            .then((res) => {
                let tempCollectionMeans = [];
                res.data.forEach(row => {
                    tempCollectionMeans.push(row);
                })
                setCollectionMeans(tempCollectionMeans);
            })
            axios.get('/api/getCompanyRepresentatives.php')
            .then((res) => {
                let tempCompanyRepresentatives = [];
                res.data.forEach(row => {
                    tempCompanyRepresentatives.push(row);
                })
                setCompanyRepresentatives(tempCompanyRepresentatives);
            })
            axios.get('/api/getRequestedPurpose.php')
            .then((res) => {
                let tempRequestedPurposes = [];
                res.data.forEach(row => {
                    tempRequestedPurposes.push(row);
                })
                setRequestedPurposes(tempRequestedPurposes);
            })
            axios.get('/api/getShipType.php')
            .then((res) => {
                let tempShipTypes = [];
                res.data.forEach(row => {
                    tempShipTypes.push(row);
                })
                setShipTypes(tempShipTypes);
            })
            axios.get('/api/getWasteMetric.php')
            .then((res) => {
                let tempWasteMetrics = [];
                res.data.forEach(row => {
                    tempWasteMetrics.push(row);
                })
                setWasteMetrics(tempWasteMetrics);
            })
            axios.get('/api/getPort.php')
            .then((res) => {
                let tempPorts = [];
                res.data.forEach(row => {
                    tempPorts.push(row);
                })
                setPortOfDeliveries(tempPorts);
            })
            axios.get('/api/getLocation.php')
            .then((res) => {
                let tempLocations = [];
                res.data.forEach(row => {
                    tempLocations.push(row);
                })
                console.log(tempLocations);
                setLocations(tempLocations);
            })
            axios.get('/api/getAgents.php')
            .then((res) => {
                console.log(res.data);
                let tempAgents = [];
                res.data.forEach(row => {
                    tempAgents.push(row);
                })
                setAgents(tempAgents);
            })
        }
    }, []);

    const SetFormData = (data, status, requestedAt) => {
        SetShip(data);
        if(data.registryOffice){
            setRegistryOffice({
                hasError: false,
                value: data.registryOffice
            })
        }

        if(data.contactPersonFName){
            setContactPersonFName({
                hasError: false,
                value: data.contactPersonFName
            })
        }
        if(data.contactPersonLName){
            setContactPersonLName({
                hasError: false,
                value: data.contactPersonLName
            })
        }
        if(data.contactPersonEmail){
            setContactPersonEmail({
                hasError: false,
                value: data.contactPersonEmail
            })
        }
        if(data.contactPersonPhone){
            setContactPersonPhone({
                hasError: false,
                value: data.contactPersonPhone
            })
        }
        if(data.contactPersonProfession){
            setContactPersonProfession({
                hasError: false,
                value: data.contactPersonProfession
            })
        }

        if(data.portOfDelivery){
            let tempKey = 0;
            portOfDeliveries.forEach(p => {
                if(p.value == data.portOfDelivery)
                    tempKey = p.key;
            })
            setPortOfDelivery({
                hasError: false,
                key: tempKey,
                value: data.portOfDelivery
            })
        }
        if(data.location){
            setLocation({
                hasError: false,
                value: data.location
            })
        }
        if(data.agent){
            setAgent(data.agent);
        }
        
        if(data.arrival){
            setArrival({
                hasError: false,
                value: data.arrival
            })
        }
        if(data.departure){
            setDeparture({
                hasError: false,
                value: data.departure
            })
        }
        if(data.requestedDelivery){
            setRequestedDelivery({
                hasError: false,
                value: data.requestedDelivery
            })
        }
        if(data.lastPort){
            setLastPort({
                hasError: false,
                value: data.lastPort
            })
        }
        if(data.nextPort){
            setNextPort({
                hasError: false,
                value: data.nextPort
            })
        }

        if(data.personsOnBoardCrew){
            setPersonsOnBoardCrew({
                hasError: false,
                value: data.personsOnBoardCrew
            })
        }
        if(data.personsOnBoardPassengers){
            setPersonsOnBoardPassengers({
                hasError: false,
                value: data.personsOnBoardPassengers
            })
        }
        if(data.personsOnBoardTotal){
            setPersonsOnBoardTotal({
                hasError: false,
                value: data.personsOnBoardTotal
            })
        }

        if(data.comments){
            setComments(data.comments);
        }
        
        if(data.requestedCollectionMeans.length > 0)
            setRequestedCollectionMeans(data.requestedCollectionMeans);
        
        setAnnex1non(data.annex1non);
        setAnnex2non(data.annex2non);
        setAnnex4non(data.annex4non);
        setAnnex5non(data.annex5non);
        setAnnex6non(data.annex6non);

        setAnnex1(data.annex1);
        setAnnex2(data.annex2);
        setAnnex4(data.annex4);
        setAnnex5(data.annex5);
        setAnnex6(data.annex6);

        setAnnex1nonKey(prev => prev+1);
        setAnnex2nonKey(prev => prev+1);
        setAnnex4nonKey(prev => prev+1);
        setAnnex5nonKey(prev => prev+1);
        setAnnex6nonKey(prev => prev+1);

        setAnnex1Key(prev => prev+1);
        setAnnex2Key(prev => prev+1);
        setAnnex4Key(prev => prev+1);
        setAnnex5Key(prev => prev+1);
        setAnnex6Key(prev => prev+1);

        setRequestedCollectionMeansKey(prev => prev+1);

        setStatus(status);
        setRequestedAt(FormatDatetime(requestedAt));

        setGotData(true);

        // annex1non,
        // annex2non,
        // annex4non,
        // annex5non,
        // annex6non,
        // annex1,
        // annex2,
        // annex4,
        // annex5,
        // annex6,
        // comments
    }

    const HasCheckedAnnex1Non = (obj) => {
        let result = false;
        let toCheck = [obj.oilyBilgeWater, obj.oilyResidues, obj.oilyTank, obj.dirtyBallast, obj.scale, obj.other];
        toCheck.forEach(c => {
            if(c?.active && c?.data?.ew && c?.data?.wasteForDelivery)
                result = true;
        })
        return result;
    }
    const HasCheckedAnnex2Non = (obj) => {
        let result = false;
        let toCheck = [obj.categoryX, obj.categoryY, obj.categoryZ, obj.other];
        toCheck.forEach(c => {
            if(c?.active && c?.data?.ew && c?.data?.wasteForDelivery)
                result = true;
        })
        return result;
    }
    const HasCheckedAnnex4Non = (obj) => {
        let result = false;
        let toCheck = [obj.sewage];
        toCheck.forEach(c => {
            if(c?.active && c?.data?.ew && c?.data?.wasteForDelivery)
                result = true;
        })
        return result;
    }
    const HasCheckedAnnex5Non = (obj) => {
        let result = false;
        let toCheck = [obj.plastic, obj.foodWaste, obj.domesticWaste, obj.cookingOil, obj.incineratorAsh, obj.operationalWaste, obj.animalCarcasses, obj.fishingGear, obj.eWaste, obj.cargo, obj.other];
        toCheck.forEach(c => {
            if(c?.active && c?.data?.ew && c?.data?.wasteForDelivery)
                result = true;
        })
        return result;
    }
    const HasCheckedAnnex6Non = (obj) => {
        let result = false;
        let toCheck = [obj.ozone, obj.exhaust];
        toCheck.forEach(c => {
            if(c?.active && c?.data?.ew && c?.data?.wasteForDelivery)
                result = true;
        })
        return result;
    }

    const HasCheckedAnnex1 = (obj) => {
        let result = false;
        let toCheck = [obj.oily, obj.other];
        toCheck.forEach(c => {
            if(c?.active && c?.data?.ew && c?.data?.wasteForDelivery)
                result = true;
        })
        return result;
    }
    const HasCheckedAnnex2 = (obj) => {
        let result = false;
        let toCheck = [obj.categoryX, obj.categoryY, obj.categoryZ, obj.other];
        toCheck.forEach(c => {
            if(c?.active && c?.data?.ew && c?.data?.wasteForDelivery)
                result = true;
        })
        return result;
    }
    const HasCheckedAnnex4 = (obj) => {
        let result = false;
        let toCheck = [obj.sewage];
        toCheck.forEach(c => {
            if(c?.active && c?.data?.ew && c?.data?.wasteForDelivery)
                result = true;
        })
        return result;
    }
    const HasCheckedAnnex5 = (obj) => {
        let result = false;
        let toCheck = [obj.paint, obj.printing, obj.photo, obj.med, obj.leadBat, obj.otherBat, obj.dangerous, obj.oilyRags, obj.other];
        toCheck.forEach(c => {
            if(c?.active && c?.data?.ew && c?.data?.wasteForDelivery)
                result = true;
        })
        return result;
    }
    const HasCheckedAnnex6 = (obj) => {
        let result = false;
        let toCheck = [obj.ozone, obj.exhaust];
        toCheck.forEach(c => {
            if(c?.active && c?.data?.ew && c?.data?.wasteForDelivery)
                result = true;
        })
        return result;
    }

  const CheckMandatory = () => {
    // const mandatoryFields = [imo, shipName, shipType, grossTonnage, grt, dwt, registryOffice,
    //                             personsOnBoard.crew,
    //                             contactPerson.fName, contactPerson.lName, contactPerson.email, contactPerson.phone];
    // const mandatoryFields = [imo, shipName, shipType, grossTonnage, grt, dwt, registryOffice];
    let check = true;
    
    setImo(prev => ({...prev, hasError: false}));
    setShipName(prev => ({...prev, hasError: false}));
    setShipType(prev => ({...prev, hasError: false}));
    setCountryFlag(prev => ({...prev, hasError: false}));
    setGrossTonnage(prev => ({...prev, hasError: false}));
    setGrt(prev => ({...prev, hasError: false}));
    setDwt(prev => ({...prev, hasError: false}));
    setRegistryOffice(prev => ({...prev, hasError: false}));

    setHasCheckedAnnex(true);

    setPersonsOnBoardCrew(prev => ({...prev, hasError: false}));

    setPortOfDelivery(prev => ({...prev, hasError: false}));
    setLocation(prev => ({...prev, hasError: false}));
    setArrival(prev => ({...prev, hasError: false}));
    setDeparture(prev => ({...prev, hasError: false}));
    setRequestedDelivery(prev => ({...prev, hasError: false}));

    setContactPersonFName(prev => ({...prev, hasError: false}));
    setContactPersonLName(prev => ({...prev, hasError: false}));
    setContactPersonEmail(prev => ({...prev, hasError: false}));
    setContactPersonPhone(prev => ({...prev, hasError: false}));

    let scrollTo = 0;

    if(!imo.value){
        check = false;
        setImo(prev => ({...prev, hasError: true}))
        if(scrollTo == 0) scrollTo = dataCords0;
    }
    if(!shipName.value){
        check = false;
        setShipName(prev => ({...prev, hasError: true}))
        if(scrollTo == 0) scrollTo = dataCords0;
    }
    if(!shipType.value){
        check = false;
        setShipType(prev => ({...prev, hasError: true}))
        if(scrollTo == 0) scrollTo = dataCords0;
    }
    if(!countryFlag.value){
        check = false;
        setCountryFlag(prev => ({...prev, hasError: true}))
        if(scrollTo == 0) scrollTo = dataCords0;
    }
    if(!grossTonnage.value){
        check = false;
        setGrossTonnage(prev => ({...prev, hasError: true}))
        if(scrollTo == 0) scrollTo = dataCords0;
    }
    if(!grt.value){
        check = false;
        setGrt(prev => ({...prev, hasError: true}))
        if(scrollTo == 0) scrollTo = dataCords0;
    }
    if(!dwt.value){
        check = false;
        setDwt(prev => ({...prev, hasError: true}))
        if(scrollTo == 0) scrollTo = dataCords0;
    }
    if(!registryOffice.value){
        check = false;
        setRegistryOffice(prev => ({...prev, hasError: true}))
        if(scrollTo == 0) scrollTo = dataCords0;
    }

    if(!contactPersonFName.value){
        check = false;
        setContactPersonFName(prev => ({...prev, hasError: true}))
        if(scrollTo == 0) scrollTo = dataCords0;
    }
    if(!contactPersonLName.value){
        check = false;
        setContactPersonLName(prev => ({...prev, hasError: true}))
        if(scrollTo == 0) scrollTo = dataCords0;
    }
    if(!contactPersonEmail.value){
        check = false;
        setContactPersonEmail(prev => ({...prev, hasError: true}))
        if(scrollTo == 0) scrollTo = dataCords0;
    }
    if(!contactPersonPhone.value){
        check = false;
        setContactPersonPhone(prev => ({...prev, hasError: true}))
        if(scrollTo == 0) scrollTo = dataCords0;
    }

    if(!portOfDelivery.value){
        check = false;
        setPortOfDelivery(prev => ({...prev, hasError: true}))
        if(scrollTo == 0) scrollTo = dataCords1;
    }
    if(!location.value){
        check = false;
        setLocation(prev => ({...prev, hasError: true}))
        if(scrollTo == 0) scrollTo = dataCords1;
    }
    if(!arrival.value){
        check = false;
        setArrival(prev => ({...prev, hasError: true}))
        if(scrollTo == 0) scrollTo = dataCords1;
    }
    if(!departure.value){
        check = false;
        setDeparture(prev => ({...prev, hasError: true}))
        if(scrollTo == 0) scrollTo = dataCords1;
    }
    if(!requestedDelivery.value){
        check = false;
        setRequestedDelivery(prev => ({...prev, hasError: true}))
        if(scrollTo == 0) scrollTo = dataCords1;
    }

    if(!personsOnBoardCrew.value){
        check = false;
        setPersonsOnBoardCrew(prev => ({...prev, hasError: true}))
        if(scrollTo == 0) scrollTo = dataCords1;
    }

    const hasAnnex1non = HasCheckedAnnex1Non(annex1non);
    const hasAnnex2non = HasCheckedAnnex2Non(annex2non);
    const hasAnnex4non = HasCheckedAnnex4Non(annex4non);
    const hasAnnex5non = HasCheckedAnnex5Non(annex5non);
    const hasAnnex6non = HasCheckedAnnex6Non(annex6non);

    const hasAnnex1 = HasCheckedAnnex1(annex1);
    const hasAnnex2 = HasCheckedAnnex2(annex2);
    const hasAnnex4 = HasCheckedAnnex4(annex4);
    const hasAnnex5 = HasCheckedAnnex5(annex5);
    const hasAnnex6 = HasCheckedAnnex6(annex6);

    if(!hasAnnex1non && !hasAnnex2non && !hasAnnex4non && !hasAnnex5non && !hasAnnex6non && !hasAnnex1 && !hasAnnex2 && !hasAnnex4 && !hasAnnex5 && !hasAnnex6){
        check = false;
        setHasCheckedAnnex(false);
        if(scrollTo == 0) scrollTo = dataCords2;
    }

    // alert(scrollTo);

    if(scrollTo != 0){
        scrollRef.current.scrollTo({
            x: 0,
            y: scrollTo,
            animated: true,
        });
    }

    return check;
  }

  const toIsoString = (date) => {
    if(!date)
        return null;
    if(!date.getTimezoneOffset){
        date = new Date(date);
    }
    var tzo = -date.getTimezoneOffset(),
        dif = tzo >= 0 ? '+' : '-',
        pad = function(num) {
            return (num < 10 ? '0' : '') + num;
        };
  
    return date.getFullYear() +
        '-' + pad(date.getMonth() + 1) +
        '-' + pad(date.getDate()) +
        'T' + pad(date.getHours()) +
        ':' + pad(date.getMinutes()) +
        ':' + pad(date.getSeconds()) +
        dif + pad(Math.floor(Math.abs(tzo) / 60)) +
        ':' + pad(Math.abs(tzo) % 60);
  }

  const Submit = () => {
      if(CheckMandatory()){
          const data = {
            imo: imo.value,
            shipName: shipName.value,
            shipType: shipType.value,
            grossTonnage: grossTonnage.value,
            grossTonnageType,
            grt: grt.value,
            grtType,
            dwt: dwt.value,
            dwtType,
            countryFlag: countryFlag.value,
            registryOffice: registryOffice.value,
            contactPersonFName: contactPersonFName.value,
            contactPersonLName: contactPersonLName.value,
            contactPersonProfession: contactPersonProfession.value,
            contactPersonEmail: contactPersonEmail.value,
            contactPersonPhone: contactPersonPhone.value,
            portOfDelivery: portOfDelivery.value,
            location: location.value,
            agent,
            arrival: toIsoString(arrival.value),
            departure: toIsoString(departure.value),
            requestedDelivery: toIsoString(requestedDelivery.value),
            lastPort: lastPort.value,
            nextPort: nextPort.value,
            personsOnBoardCrew: personsOnBoardCrew.value,
            personsOnBoardPassengers: personsOnBoardPassengers.value,
            personsOnBoardTotal: personsOnBoardTotal.value,
            requestedCollectionMeans,
            annex1non,
            annex2non,
            annex4non,
            annex5non,
            annex6non,
            annex1,
            annex2,
            annex4,
            annex5,
            annex6,
            comments
          };
          if(props.id){
            data.id = props.id;
            axios.post('/api/editRequest.php', data)
            .then((res) => {
                if(!props.user.isVGroup){
                    props.openModal("Success", "Your request has been updated successfully.\nYou will be notified soon about the Waste collection details.");
                    setTimeout(() => {
                        props.navigation.navigate('My Requests');
                    },10)
                }
                else{
                    props.openModal("Success", "The request has been updated successfully.");
                    setTimeout(() => {
                        props.navigation.navigate('Manage Requests');
                    },10)
                }
            })
          }
          else{
            axios.post('/api/newRequest.php', data)
            .then((res) => {
                if(!props.user.isVGroup){
                    props.openModal("Success", "Your request has been submitted.\nYou will be notified soon about the Waste collection details.");
                    setTimeout(() => {
                        props.navigation.navigate('My Requests');
                    },10)
                }
                else{
                    props.openModal("Success", "The request has been submitted successfully.");
                    setTimeout(() => {
                        props.navigation.navigate('Manage Requests');
                    },10)
                }
            })
          }
      }
      else{
        props.openModal("Warning", "Please fill in all mandatory fields in red.");
      }
  }

  const DriverArrival = () => {
    props.openModal("Warning", "Please confirm the arrival of the driver.", async() => {
        const data = {
            id: props.id,
            status: 'Driver Arrived'
        }
        axios.post('/api/editRequestStatus.php', data)
        .then((res) => {
            props.openModal("Success", "The arrival of the driver has been confirmed.");
            setTimeout(() => {
                props.navigation.navigate('Request Info', { id: props.id });
            },100);
        })
    });
}

  const GetShipByIMO = () => {
    setShipEditable(true);
    axios.get('/api/getShip.php', {
        params: {
            imo: imo.value
        }
    })
    .then((res) => {
        if(res.data.length > 0)
            SetShip(res.data[0].data);
    })
  }
  const GetShipByName = () => {
      setShipEditable(true);
    axios.get('/api/getShip.php', {
        params: {
            shipName: shipName.value.toLowerCase()
        }
    })
    .then((res) => {
        if(res.data.length > 0)
            SetShip(res.data[0].data);
    })
  }
  const SetShip = (data) => {
    setShipEditable(false);
    setImo({
        hasError: false,
        value: (data.imo??"").toString()
    })
    setShipName({
        hasError: false,
        value: (data.shipName??"").toString()
    })
    setCountryFlag({
        hasError: false,
        value: (data.countryFlag??"").toString()
    })
    setShipName({
        hasError: false,
        value: (data.shipName??"").toString()
    })
    setGrossTonnage({
        hasError: false,
        value: (data.grossTonnage??"").toString()
    })
    setGrt({
        hasError: false,
        value: (data.grossTonnage??"").toString()
    })
    setDwt({
        hasError: false,
        value: (data.dwt??"").toString()
    })
    setShipType({
        hasError: false,
        value: (data.shipType??"").toString()
    })
    setRegistryOffice({
        hasError: false,
        value: (data.registryOffice??"").toString()
    })
    setContactPersonFName({
        hasError: false,
        value: (data.contactPersonFName??"").toString()
    })
    setContactPersonLName({
        hasError: false,
        value: (data.contactPersonLName??"").toString()
    })
    setContactPersonProfession({
        hasError: false,
        value: (data.contactPersonProfession??"").toString()
    })
    setContactPersonEmail({
        hasError: false,
        value: (data.contactPersonEmail??"").toString()
    })
    setContactPersonPhone({
        hasError: false,
        value: (data.contactPersonPhone??"").toString()
    })
  }

  const FormatDatetime = (dt) => {
    if(!dt)
        return '';
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const padLeft = (num) => {
        if(num < 10)
            return '0'+num;
        return num;
    }
    const date = new Date(dt);
    return date.getDate() + ' ' + months[date.getMonth()] + ', ' + date.getFullYear() + ', ' + padLeft(date.getHours()) + ':' + padLeft(date.getMinutes());
  }
  const Bullet = (bulletProps) => {
    const orange = '#efa270';
    const yellow = '#fed354';
    const blue = '#1aa0eb';
    const green = '#23a43f';
    const red = '#e32112';
    let color = '';
    let text = bulletProps?.text?.toString()??'';

    if(!text){
        return <></>;
    }
    if(text.startsWith('Submitted') || text.startsWith('Validated')){
        color = orange;
    }
    else if(text.startsWith('Route') || text.startsWith('Driver')){
        color = yellow;
    }
    else if(text.startsWith('Waste')){
        color = blue;
    }
    else if(text.startsWith('Certificate')){
        color = green;
    }
    else if(text.startsWith('Cancel')){
        color = red;
    }
    return <View style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
            <View style={{width: 10, height: 10, borderRadius: 5, backgroundColor: color, marginRight: 5, marginTop: 1.5}}></View>
            <MyText style={{fontSize: 10}}>{text}</MyText>
        </View>
  }

  let title = '';
  if(props.id && !isInfo){
    if(tab == 'Overview')
        title = 'Edit Request - ' + props.id;
    else
        title = 'Update Request - ' + props.id;
  }
  else if(props.id && isInfo){
      title = 'Request Info - ' + props.id;
  }
  else{
      title = 'New Request';
  }
  if(!gotData){
//   if(1==1){
      return <>
            <View style={css.background}>
                <View style={{width: '100%', flexDirection: 'row', alignItems: 'center'}}>
                    <MyText style={[css.title, css.bold]}>
                        {title}
                    </MyText>
                </View>
                {
                    !isInfo?
                    <MyText style={css.subtitle}>
                        Advance Notification Form
                    </MyText>
                    :null
                }
                {
                    isInfo?
                    <>
                        <View style={{marginTop: 10, flexDirection: 'row'}}>
                            <MyText style={{width: 120}}>Submitted On</MyText>
                            <MyText></MyText>
                        </View>
                        <View style={{marginTop: 0, flexDirection: 'row', marginBottom: 20}}>
                            <MyText style={{width: 120}}>Current Status</MyText>
                            <MyText></MyText>
                        </View>
                    </>:null
                }
                <View style={{flex: 1, justifyContent: 'center', alignItems: 'center'}}>
                    <ActivityIndicator size="large" color="#461b6f" />
                </View>
            </View>
            </>;
  }
  return (
    <ScrollView ref={scrollRef} vertical nestedScrollEnabled={true} keyboardShouldPersistTaps={'handled'} contentContainerStyle={{flexShrink: 0, flexGrow: 1}} scrollEnabled={true}>
        {/* <TouchableWithoutFeedback> */}
            <View style={css.background}>
                <View style={{width: '100%', flexDirection: 'row', alignItems: 'center'}}>
                    <MyText style={[css.title, css.bold]}>
                        {title}
                    </MyText>
                    {
                        (isInfo && ((status != 'Cancelled' && (status == 'Submitted' || status == 'Validated')) || props.user?.isVGroup))?
                        <TouchableOpacity onPress={() => props.navigation.navigate('Edit Request', {id: props.id})} style={{marginLeft: 'auto'}}>
                            <Entypo name="edit" size={18} color="#0d5cb4"/>
                        </TouchableOpacity>
                        :null
                    }
                </View>
                {
                    !isInfo?
                    <MyText style={css.subtitle}>
                        Advance Notification Form
                    </MyText>
                    :null
                }
                {
                    isInfo?
                    <>
                        <View style={{marginTop: 10, flexDirection: 'row', alignItems: 'center'}}>
                            <MyText style={{width: 120}}>Submitted On</MyText>
                            <MyText style={{fontSize: 10}}>{requestedAt}</MyText>
                        </View>
                        <View style={{marginTop: 0, flexDirection: 'row', alignItems: 'center', marginBottom: 20}}>
                            <MyText style={{width: 120}}>Current Status</MyText>
                            <Bullet text={status}/>
                        </View>
                        <View style={{
                                borderColor: '#e0dde3',
                                borderTopWidth: 1,
                                borderBottomWidth: 1,
                                // flex: 1,
                                marginBottom: 20,
                                justifyContent: 'center',
                                alignItems: 'center',
                                flexDirection: 'row'
                            }}>
                            <TouchableOpacity onPress={() => setTab('Overview')}>
                                <View style={[{elevation: tab=='Overview'?10:0, backgroundColor: tab=='Overview'?'#eae2f1':null}, styles.updateRequestTab]}>
                                    <MyText style={[{color: tab=='Overview'?'#522c75':'#919293'}, css.bold]}>Overview</MyText>
                                </View>
                            </TouchableOpacity>
                            <TouchableOpacity onPress={() => setTab('Progress')}>
                                <View style={[{elevation: tab=='Progress'?10:0, backgroundColor: tab=='Progress'?'#eae2f1':null}, styles.updateRequestTab]}>
                                    <MyText style={{color: tab=='Progress'?'#522c75':'#919293'}}>Progress</MyText>
                                </View>
                            </TouchableOpacity>
                            <TouchableOpacity style={styles.tab} onPress={() => (status == 'Route Scheduled' || status == 'Driver Arrived' || status == 'Waste Collected' || status == 'Waste Segregated' || status == 'Certificate Issued')?setTab('Route Update'):false}>
                                <View style={[{elevation: tab=='Route Update'?10:0, backgroundColor: tab=='Route Update'?'#eae2f1':null}, styles.updateRequestTab]}>
                                    <MyText style={{color: tab=='Route Update'?'#522c75':'#919293', textAlign: 'center'}}>{'Route'}</MyText>
                                </View>
                            </TouchableOpacity>
                            <TouchableOpacity style={styles.tab} onPress={() => (status == 'Waste Collected' || status == 'Waste Segregated' || status == 'Certificate Issued')?setTab('Waste Collection'):false}>
                                <View style={[{elevation: tab=='Waste Collection'?10:0, backgroundColor: tab=='Waste Collection'?'#eae2f1':null}, styles.updateRequestTab]}>
                                    <MyText style={{color: tab=='Waste Collection'?'#522c75':'#919293', textAlign: 'center'}}>{'Waste\nCollection'}</MyText>
                                </View>
                            </TouchableOpacity>
                        </View>
                    </>:null
                }
                {
                    (!isInfo && props.id && props.user.isVGroup)?
                    <>
                        <View style={{
                                borderColor: '#e0dde3',
                                borderTopWidth: 1,
                                borderBottomWidth: 1,
                                // flex: 1,
                                marginBottom: 20,
                                marginTop: 20,
                                justifyContent: 'center',
                                alignItems: 'center',
                                flexDirection: 'row'
                            }}>
                            <TouchableOpacity style={styles.tab} onPress={() => setTab('Overview')}>
                                <View style={[{elevation: tab=='Overview'?10:0, backgroundColor: tab=='Overview'?'#eae2f1':null}, styles.updateRequestTab]}>
                                    <MyText style={[{color: tab=='Overview'?'#522c75':'#919293'}, css.bold]}>Edit</MyText>
                                </View>
                            </TouchableOpacity>
                            <TouchableOpacity style={styles.tab} onPress={() => (status == 'Validated' || status == 'Route Scheduled')?setTab('Route Update'):false}>
                                <View style={[{elevation: tab=='Route Update'?10:0, backgroundColor: tab=='Route Update'?'#eae2f1':null}, styles.updateRequestTab]}>
                                    <MyText style={{color: tab=='Route Update'?'#522c75':'#919293', textAlign: 'center'}}>{'Route\nUpdate'}</MyText>
                                </View>
                            </TouchableOpacity>
                            <TouchableOpacity style={styles.tab} onPress={() => status == 'Route Scheduled'?DriverArrival():false}>
                                <View style={[{elevation: tab=='Arrival'?10:0, backgroundColor: tab=='Arrival'?'#eae2f1':null}, styles.updateRequestTab]}>
                                    <MyText style={{color: tab=='Arrival'?'#522c75':'#919293', textAlign: 'center'}}>{'Arrival'}</MyText>
                                </View>
                            </TouchableOpacity>
                            <TouchableOpacity style={styles.tab} onPress={() => setTab('Waste Collection')}>
                                <View style={[{elevation: tab=='Waste Collection'?10:0, backgroundColor: tab=='Waste Collection'?'#eae2f1':null}, styles.updateRequestTab]}>
                                    <MyText style={{color: tab=='Waste Collection'?'#522c75':'#919293', textAlign: 'center'}}>{'Waste\nCollection'}</MyText>
                                </View>
                            </TouchableOpacity>
                            <TouchableOpacity style={styles.tab} onPress={() => setTab('Waste Segregation')}>
                                <View style={[{elevation: tab=='Waste Segregation'?10:0, backgroundColor: tab=='Waste Segregation'?'#eae2f1':null}, styles.updateRequestTab]}>
                                    <MyText style={{color: tab=='Waste Segregation'?'#522c75':'#919293', textAlign: 'center'}}>{'Waste\nSegregation'}</MyText>
                                </View>
                            </TouchableOpacity>
                        </View>
                    </>:null
                }
                { tab=='Overview'? 
                <>
                    {/* Ship Particulars */}
                    <View style={[{zIndex: 10}, css.form]} onLayout={(event) => {setDataCords0(event.nativeEvent.layout.y)}}>
                        <MyText style={[css.formTitle, css.bold]}>
                        Ship Particulars
                        </MyText>
                        <View
                        style={{
                            borderBottomColor: '#f3f1f8',
                            borderBottomWidth: 2,
                        }}
                        />
                        <View style={css.formContainer}>
                        <View style={css.formRow}>
                            <MyText style={css.formRowLabel}>
                            IMO
                            </MyText>
                            <MyTextInput
                                inputMode='decimal'
                                keyboardType='phone-pad'
                                style={css.formRowInput}
                                onChangeText={(e) => {
                                        setImo(prev => ({
                                            ...prev,
                                            value: e
                                        }))
                                    }
                                }
                                onBlur={(e) => {
                                    GetShipByIMO();
                                }}
                                value={imo.value}
                                hasError={imo.hasError}
                                validation='imo'
                                editable={props.id==undefined}
                                isInfo={isInfo}
                            />
                        </View>
                        <View style={css.formRow}>
                            <MyText style={css.formRowLabel}>
                            Ship Name
                            </MyText>
                            <MyTextInput
                                style={css.formRowInput}
                                onChangeText={(e) => setShipName(prev => ({
                                    ...prev,
                                    value: e
                                }))}
                                onBlur={(e) => {
                                    GetShipByName();
                                }}
                                value={shipName.value}
                                hasError={shipName.hasError}
                                editable={props.id==undefined}
                                isInfo={isInfo}
                            />
                        </View>
                        <View style={[{zIndex: 10}, css.formRow]}>
                            <MyText style={css.formRowLabel}>
                            Ship Type
                            </MyText>
                            <MyPicker
                            style={css.formRowInput}
                            //   items={['Container', 'Bulk', 'Tanker', 'Passenger', 'Naval', 'Offshore', 'Special Purpose']}
                            items={shipTypes}
                            onValueChange={(item, itemIndex) => setShipType(prev => ({
                                    ...prev,
                                    value: item.value
                                }))}
                                value={shipType.value}
                                hasError={shipType.hasError}
                                editable={shipEditable}
                                isInfo={isInfo}
                            >
                            </MyPicker>
                        </View>
                        <View style={[{zIndex: 9}, css.formRow]}>
                            <MyText style={css.formRowLabel}>
                            Gross Tonnage
                            </MyText>
                            <View style={[{flex: 1}, css.doubleInput]}>
                            <MyTextInput
                                inputMode='decimal'
                                keyboardType='phone-pad'
                                style={[{flexGrow: 1, flexShrink: 1, marginRight: 5}, css.formRowInput]}
                                onChangeText={(e) => setGrossTonnage(prev => ({
                                    ...prev,
                                    value: e
                                }))}
                                value={grossTonnage.value}
                                hasError={grossTonnage.hasError}
                                editable={shipEditable}
                                isInfo={isInfo}
                            />
                            <View style={css.secondInput}>
                                <MyPicker
                                    style={css.formRowInput}
                                    width={65}
                                    items={wasteMetrics}
                                    value={grossTonnageType}
                                    onValueChange={(item, itemIndex) =>
                                        setGrossTonnageType(item.value)
                                    }
                                    editable={shipEditable}
                                    isInfo={isInfo}
                                >
                                </MyPicker>
                            </View>
                            </View>
                        </View>
                        <View style={[{zIndex: 8}, css.formRow]}>
                            <MyText style={css.formRowLabel}>
                            GRT
                            </MyText>
                            <View style={[{flex: 1}, css.doubleInput]}>
                            <MyTextInput
                                inputMode='decimal'
                                keyboardType='phone-pad'
                                style={[{flexGrow: 1, flexShrink: 1, marginRight: 5}, css.formRowInput]}
                                onChangeText={(e) => setGrt(prev => ({
                                    ...prev,
                                    value: e
                                }))}
                                value={grt.value}
                                hasError={grt.hasError}
                                editable={shipEditable}
                                isInfo={isInfo}
                            />
                            <View style={css.secondInput}>
                                <MyPicker
                                    style={css.formRowInput}
                                    width={65}
                                    items={wasteMetrics}
                                    value={grtType}
                                    onValueChange={(item, itemIndex) =>
                                        setGrtType(item.value)
                                    }
                                    editable={shipEditable}
                                    isInfo={isInfo}
                                >
                                </MyPicker>
                            </View>
                            </View>
                        </View>
                        <View style={[{zIndex: 7}, css.formRow]}>
                            <MyText style={css.formRowLabel}>
                            DWT
                            </MyText>
                            <View style={[{flex: 1}, css.doubleInput]}>
                            <MyTextInput
                                inputMode='decimal'
                                keyboardType='phone-pad'
                                style={[{flexGrow: 1, flexShrink: 1, marginRight: 5}, css.formRowInput]}
                                onChangeText={(e) => setDwt(prev => ({
                                    ...prev,
                                    value: e
                                }))}
                                value={dwt.value}
                                hasError={dwt.hasError}
                                editable={shipEditable}
                                isInfo={isInfo}
                            />
                            <View style={css.secondInput}>
                                <MyPicker
                                    style={css.formRowInput}
                                    width={65}
                                    items={wasteMetrics}
                                    value={dwtType}
                                    onValueChange={(item, itemIndex) =>
                                        setDwtType(item.value)
                                    }
                                    editable={shipEditable}
                                    isInfo={isInfo}
                                >
                                </MyPicker>
                            </View>
                            </View>
                        </View>
                        <View style={[{zIndex: 6}, css.formRow]} onLayout={(event) => {setCountryFlagCords(event.nativeEvent.layout.y)}}>
                            <MyText style={css.formRowLabel}>
                            Country Flag
                            </MyText>
                            <MyPicker
                                style={css.formRowInput}
                                items={countries}
                                onValueChange={(item, itemIndex) => setCountryFlag(prev => ({
                                    ...prev,
                                    key: item.key,
                                    value: item.value
                                }))}
                                showSearch={true}
                                value={countryFlag.value}
                                hasError={countryFlag.hasError}
                                editable={shipEditable}
                                willShow={() => {
                                        scrollRef.current.scrollTo({
                                            x: 0,
                                            y: countryFlagCords,
                                            animated: false,
                                        })
                                    }
                                }
                                isInfo={isInfo}
                            >
                            </MyPicker>
                        </View>
                        <View style={css.formRow}>
                            <MyText style={css.formRowLabel}>
                            Registry Office
                            </MyText>
                            <MyTextInput
                            style={css.formRowInput}
                            onChangeText={(e) => setRegistryOffice(prev => ({
                                ...prev,
                                value: e
                            }))}
                            value={registryOffice.value}
                            hasError={registryOffice.hasError}
                            isInfo={isInfo}
                            editable={shipEditable}
                            />
                        </View>
                        <View style={css.formRow} onLayout={(event) => {setDataCords1(event.nativeEvent.layout.y)}}>
                            <View style={{flex: 1}}>
                                <MyText style={[styles.contactPersonTitle]}>
                                    Contact Person
                                </MyText>
                                <View style={styles.container}>
                                    <View style={[{zIndex: 10}, css.formRow]}>
                                        <MyText style={css.formRowLabel}>
                                            First Name
                                        </MyText>
                                        <MyTextInput
                                            style={css.formRowInput}
                                            onChangeText={(e) => setContactPersonFName(prev => ({
                                                ...prev,
                                                value: e
                                            }))}
                                            value={contactPersonFName.value}
                                            hasError={contactPersonFName.hasError}
                                            isInfo={isInfo}
                                        />
                                    </View>
                                    <View style={[{zIndex: 9}, css.formRow]}>
                                        <MyText style={css.formRowLabel}>
                                            Last Name
                                        </MyText>
                                        <MyTextInput
                                            style={css.formRowInput}
                                            onChangeText={(e) => setContactPersonLName(prev => ({
                                                ...prev,
                                                value: e
                                            }))}
                                            value={contactPersonLName.value}
                                            hasError={contactPersonLName.hasError}
                                            isInfo={isInfo}
                                        />
                                    </View>
                                    <View style={[{zIndex: 9}, css.formRow]}>
                                        <MyText style={css.formRowLabel}>
                                            Profession
                                        </MyText>
                                        <MyTextInput
                                            style={css.formRowInput}
                                            onChangeText={(e) => setContactPersonProfession(prev => ({
                                                ...prev,
                                                value: e
                                            }))}
                                            value={contactPersonProfession.value}
                                            hasError={contactPersonProfession.hasError}
                                            isInfo={isInfo}
                                        />
                                    </View>
                                    <View style={[{zIndex: 9}, css.formRow]}>
                                        <MyText style={css.formRowLabel}>
                                            Email
                                        </MyText>
                                        <MyTextInput
                                            style={css.formRowInput}
                                            onChangeText={(e) => setContactPersonEmail(prev => ({
                                                ...prev,
                                                value: e
                                            }))}
                                            value={contactPersonEmail.value}
                                            hasError={contactPersonEmail.hasError}
                                            inputMode='email'
                                            keyboardType='email-address'
                                            validation='email'
                                            isInfo={isInfo}
                                            autoCapitalize='none'
                                            autoCorrect={false}
                                        />
                                    </View>
                                    <View style={[{zIndex: 9}, css.formRow]}>
                                        <MyText style={css.formRowLabel}>
                                            Phone
                                        </MyText>
                                        <MyTextInput
                                            inputMode='decimal'
                                            keyboardType='phone-pad'
                                            style={css.formRowInput}
                                            onChangeText={(e) => setContactPersonPhone(prev => ({
                                                ...prev,
                                                value: e
                                            }))}
                                            value={contactPersonPhone.value}
                                            hasError={contactPersonPhone.hasError}
                                            validation='phone'
                                            isInfo={isInfo}
                                        />
                                    </View>
                                </View>
                            </View>
                        </View>
                    </View>
                </View>
                {/* Port & Voyage Particulars */}
                <View style={[{zIndex: 10}, css.form]} onLayout={(event) => {setDataCords1(event.nativeEvent.layout.y)}}>
                        <MyText style={[css.formTitle, css.bold]}>
                        Port &amp; Voyage Particulars
                        </MyText>
                        <View
                        style={{
                            borderBottomColor: '#f3f1f8',
                            borderBottomWidth: 2,
                        }}
                        />
                        <View style={css.formContainer}>
                        <View style={css.formRow}>
                            <MyText style={css.formRowLabel}>
                            Port of Delivery
                            </MyText>
                            <MyPicker
                                style={css.formRowInput}
                                items={portOfDeliveries}
                                onValueChange={(item, itemIndex) => {
                                    setPortOfDelivery(prev => ({
                                            ...prev,
                                            key: item.key,
                                            value: item.value
                                    }))
                                    setLocation(prev => ({
                                        ...prev,
                                        value: null
                                    }))
                                    }
                                }
                                value={portOfDelivery.value}
                                hasError={portOfDelivery.hasError}
                                isInfo={isInfo}
                            >
                            </MyPicker>
                        </View>
                        <View style={css.formRow}>
                            <MyText style={css.formRowLabel}>
                            Location
                            </MyText>
                            <MyPicker
                                style={css.formRowInput}
                                items={locations?.filter(loc => loc.port_id === portOfDelivery.key)}
                                onValueChange={(item, itemIndex) => setLocation(prev => ({
                                    ...prev,
                                    value: item.value
                                }))}
                                value={location.value}
                                hasError={location.hasError}
                                isInfo={isInfo}
                            >
                            </MyPicker>
                        </View>
                        <View style={[{zIndex: 10}, css.formRow]}>
                            <MyText style={css.formRowLabel}>
                            Agent
                            </MyText>
                            <MyPicker
                                style={css.formRowInput}
                                value={agent}
                                items={agents}
                                onValueChange={(item, itemIndex) =>
                                    setAgent(item.value)
                                }
                                isInfo={isInfo}
                            >
                            </MyPicker>
                        </View>
                        <View style={[{zIndex: 9}, css.formRow]}>
                            <MyText style={css.formRowLabel} >
                                Arrival
                            </MyText>
                            <View style={[{flex: 1}, css.doubleInput]}>
                                <MyDateTimePicker 
                                    onChange={(e) => setArrival(prev => ({
                                        ...prev,
                                        value: e
                                    }))}
                                    value={arrival.value?new Date(arrival.value):null}
                                    hasError={arrival.hasError}
                                    isInfo={isInfo}
                                />
                            </View>
                        </View>
                        <View style={[{zIndex: 8}, css.formRow]}>
                            <MyText style={css.formRowLabel}>
                            Departure
                            </MyText>
                            <View style={[{flex: 1}, css.doubleInput]}>
                                <MyDateTimePicker
                                    onChange={(e) => setDeparture(prev => ({
                                        ...prev,
                                        value: e
                                    }))}
                                    value={departure.value?new Date(departure.value):null}
                                    hasError={departure.hasError}
                                    isInfo={isInfo}
                                />
                            </View>
                        </View>
                        <View style={[{zIndex: 7}, css.formRow]}>
                            <MyText style={css.formRowLabel}>
                            Requested Delivery
                            </MyText>
                            <View style={[{flex: 1}, css.doubleInput]}>
                                <MyDateTimePicker
                                    onChange={(e) => setRequestedDelivery(prev => ({
                                        ...prev,
                                        value: e
                                    }))}
                                    value={requestedDelivery.value?new Date(requestedDelivery.value):null}
                                    hasError={requestedDelivery.hasError}
                                    isInfo={isInfo}
                                />
                            </View>
                        </View>
                        <View style={[{zIndex: 6}, css.formRow]}>
                            <MyText style={css.formRowLabel}>
                            Last Port
                            </MyText>
                            <MyTextInput
                                style={css.formRowInput}
                                onChangeText={(e) => setLastPort(prev => ({
                                    ...prev,
                                    value: e
                                }))}
                                value={lastPort.value}
                                hasError={lastPort.hasError}
                                isInfo={isInfo}
                            />
                        </View>
                        <View style={css.formRow}>
                            <MyText style={css.formRowLabel}>
                            Next Port
                            </MyText>
                            <MyTextInput
                                style={css.formRowInput}
                                onChangeText={(e) => setNextPort(prev => ({
                                    ...prev,
                                    value: e
                                }))}
                                value={nextPort.value}
                                hasError={nextPort.hasError}
                                isInfo={isInfo}
                            />
                        </View>
                        <View style={css.formRow}>
                            <View style={{flex: 1}}>
                                <MyText style={[styles.personsOnBoardTitle]}>
                                    Number of Persons onboard
                                </MyText>
                                <View style={styles.container}>
                                    <View style={[{zIndex: 10}, css.formRow]}>
                                        <MyText style={css.formRowLabel}>
                                            Crew Members
                                        </MyText>
                                        <MyTextInput
                                            inputMode='decimal'
                                            keyboardType='phone-pad'
                                            style={css.formRowInput}
                                            onChangeText={(e) => {
                                                    setPersonsOnBoardCrew(prev => ({
                                                        ...prev,
                                                        value: e
                                                    }));
                                                    setPersonsOnBoardTotal(prev => ({
                                                        ...prev,
                                                        value: ((parseInt(e)||0) + (parseInt(personsOnBoardPassengers.value)||0)).toString()
                                                    }));
                                                }
                                            }
                                            value={personsOnBoardCrew.value}
                                            hasError={personsOnBoardCrew.hasError}
                                            isInfo={isInfo}
                                        />
                                    </View>
                                    <View style={[{zIndex: 9}, css.formRow]}>
                                        <MyText style={css.formRowLabel}>
                                            Passengers
                                        </MyText>
                                        <MyTextInput
                                            inputMode='decimal'
                                            keyboardType='phone-pad'
                                            style={css.formRowInput}
                                            onChangeText={(e) => {
                                                    setPersonsOnBoardPassengers(prev => ({
                                                        ...prev,
                                                        value: e
                                                    }));
                                                    setPersonsOnBoardTotal(prev => ({
                                                        ...prev,
                                                        value: ((parseInt(e)||0) + (parseInt(personsOnBoardCrew.value)||0)).toString()
                                                    }));
                                                }
                                            }
                                            value={personsOnBoardPassengers.value}
                                            hasError={personsOnBoardPassengers.hasError}
                                            isInfo={isInfo}
                                        />
                                    </View>
                                    <View style={[{zIndex: 10}, css.formRow]}>
                                        <MyText style={css.formRowLabel}>
                                            Total
                                        </MyText>
                                        <MyTextInput
                                            inputMode='decimal'
                                            keyboardType='phone-pad'
                                            style={css.formRowInput}
                                            // onChangeText={(e) => setPersonsOnBoardTotal(prev => ({
                                            //     ...prev,
                                            //     value: e
                                            // }))}
                                            value={personsOnBoardTotal.value}
                                            hasError={personsOnBoardTotal.hasError}
                                            editable={false}
                                            isInfo={isInfo}
                                        />
                                    </View>
                                </View>
                            </View>
                        </View>
                    </View>
                </View>
                {/* Requested Collection Means*/}
                <View style={[{zIndex: 9}, css.form]}>
                    <RequestedCollectionMeans value={requestedCollectionMeans} onChange={setRequestedCollectionMeans} collectionMeans={collectionMeans} purposes={requestedPurposes} key={requestedCollectionMeansKey} isInfo={isInfo}/>
                </View>
                {/* Type & Amount of Waste*/}
                <View style={[{zIndex: 9}, css.form]} onLayout={(event) => {setDataCords2(event.nativeEvent.layout.y)}}>
                    <MyText style={[css.formTitle, css.bold]}>
                    Type &amp; Amount of Waste
                    </MyText>
                    <MyText style={{display: hasCheckedAnnex?'none':'flex', color: 'red', fontSize: 7, textAlign: 'center', position: 'relative', top: -4}}>
                        Please select at least one Waste Type and fill in all mandatory fields in red
                    </MyText>
                    <View
                    style={{
                        borderBottomColor: '#f3f1f8',
                        borderBottomWidth: 2,
                    }}
                    />
                    <View style={css.formContainer}>
                    <MyText style={[css.bold, css.formSubtitle]}>
                        Non-Hazardous
                    </MyText>
                    </View>
                    <AnnexINonHazardous wasteMetrics={wasteMetrics} hasOne={HasCheckedAnnex1Non(annex1non)} checked={props.id?HasCheckedAnnex1Non(annex1non):false} onChange={setAnnex1non} value={annex1non} key={annex1nonKey} isInfo={isInfo}/>
                    <AnnexIINonHazardous wasteMetrics={wasteMetrics} hasOne={HasCheckedAnnex2Non(annex2non)} checked={props.id?HasCheckedAnnex2Non(annex2non):false} onChange={setAnnex2non} value={annex2non} key={annex2nonKey} isInfo={isInfo}/>
                    <AnnexIVNonHazardous wasteMetrics={wasteMetrics} hasOne={HasCheckedAnnex4Non(annex4non)} checked={props.id?HasCheckedAnnex4Non(annex4non):false} onChange={setAnnex4non} value={annex4non} key={annex4nonKey} isInfo={isInfo}/>
                    <AnnexVNonHazardous wasteMetrics={wasteMetrics} hasOne={HasCheckedAnnex5Non(annex5non)} checked={props.id?HasCheckedAnnex5Non(annex5non):false} onChange={setAnnex5non} value={annex5non} key={annex5nonKey} isInfo={isInfo}/>
                    <AnnexVINonHazardous wasteMetrics={wasteMetrics} hasOne={HasCheckedAnnex6Non(annex6non)} checked={props.id?HasCheckedAnnex6Non(annex6non):false} onChange={setAnnex6non} value={annex6non} key={annex6nonKey} isInfo={isInfo}/>
                    <View
                    style={{
                        borderBottomColor: '#f3f1f8',
                        borderBottomWidth: 2,
                    }}
                    />
                    <View style={css.formContainer}>
                    <MyText style={[css.bold, css.formSubtitle]}>
                        Hazardous
                    </MyText>
                    </View>
                    <AnnexIHazardous wasteMetrics={wasteMetrics} hasOne={HasCheckedAnnex1(annex1)} checked={props.id?HasCheckedAnnex1(annex1):false} onChange={setAnnex1} value={annex1} key={annex1Key} isInfo={isInfo}/>
                    <AnnexIIHazardous wasteMetrics={wasteMetrics} hasOne={HasCheckedAnnex2(annex2)} checked={props.id?HasCheckedAnnex2(annex2):false} onChange={setAnnex2} value={annex2} key={annex2Key} isInfo={isInfo}/>
                    <AnnexIVHazardous wasteMetrics={wasteMetrics} hasOne={HasCheckedAnnex4(annex4)} checked={props.id?HasCheckedAnnex4(annex4):false} onChange={setAnnex4} value={annex4} key={annex4Key} isInfo={isInfo}/>
                    <AnnexVHazardous wasteMetrics={wasteMetrics} hasOne={HasCheckedAnnex5(annex5)} checked={props.id?HasCheckedAnnex5(annex5):false} onChange={setAnnex5} value={annex5} key={annex5Key} isInfo={isInfo}/>
                    <AnnexVIHazardous wasteMetrics={wasteMetrics} hasOne={HasCheckedAnnex6(annex6)} checked={props.id?HasCheckedAnnex6(annex6):false} onChange={setAnnex6} value={annex6} key={annex6Key} isInfo={isInfo}/>
                </View>
                {/* Comments */}
                <View style={[{zIndex: 9}, css.form]}>
                    <MyText style={[css.formTitle, css.bold]}>
                    Comments
                    </MyText>
                    <View
                    style={{
                        borderBottomColor: '#f3f1f8',
                        borderBottomWidth: 2,
                    }}
                    />
                    <View style={css.formContainer}>
                        <MyTextarea
                            style={[{flexGrow: 1, flexShrink: 0, marginRight: 5}, css.formRowInput]}
                            onChangeText={setComments}
                            value={comments}
                            placeholder="Please provide any additional information regarding your request"
                            isInfo={isInfo}
                        />
                    </View>
                </View>
                {
                    !isInfo?
                    <TouchableOpacity onPress={() => Submit()} style={{alignItems: 'center', marginBottom: 20}}>
                        <MyText style={[css.button, css.bold]}>
                            {props.id?'Update':'Submit'}
                        </MyText>
                    </TouchableOpacity>
                    :null
                }
            </>:null
            }
            {
                tab=='Progress'?
                <Progress data={progressData} location={location} portOfDelivery={portOfDelivery}/>
                :null
            }
            {
                tab=='Route Update'?
                <RouteUpdate id={props.id} navigation={props.navigation} requestedDelivery={requestedDelivery.value} value={(routeUpdateData&&routeUpdateData.length>0)?routeUpdateData:requestedCollectionMeans} onChange={setRouteUpdateData} collectionMeans={collectionMeans} companyRepresentatives={companyRepresentatives} purposes={requestedPurposes} key={requestedCollectionMeansKey} isInfo={isInfo}/>
                :null
            }
            {
                tab=='Waste Collection'?
                <WasteCollection 
                    id={props.id}
                    navigation={props.navigation}
                    comments={comments}
                    data={wasteCollectionData}
                    annex1={annex1}
                    annex2={annex2}
                    annex4={annex4}
                    annex5={annex5}
                    annex6={annex6}
                    annex1non={annex1non}
                    annex2non={annex2non}
                    annex4non={annex4non}
                    annex5non={annex5non}
                    annex6non={annex6non}
                    isInfo={isInfo}
                />
                :null
            }
        </View>
        {/* </TouchableWithoutFeedback> */}
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1
  },
  input: {
    height: 40,
    margin: 12,
    borderWidth: 1,
    padding: 10,
  },
  personsOnBoardTitle: {
    color: '#461b6f',
    fontSize: 14,
    paddingVertical: 15,
  },
  contactPersonTitle: {
    color: '#461b6f',
    fontSize: 14,
    paddingVertical: 15,
  },
  tab: {

  },
  updateRequestTab: {
    paddingVertical: 7,
    paddingHorizontal: 10,
    flex: 1,
    justifyContent: 'center',
  }
});

const mapDispatchToProps = {
    openModal,
    closeModal,
}

export default connect(null, mapDispatchToProps)(NewRequest)